import React, { useRef, useEffect } from "react";
import "./Companies.css";
import AOS from "aos";
import "aos/dist/aos.css";

import hcl from "../../assets/hcl.png";
import tcs from "../../assets/tcs.png";
import turing from "../../assets/turing.png";
import genpact from "../../assets/genpact.png";
import lti from "../../assets/lti.png";

const Companies = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    // 🔹 Auto-scroll (slow & smooth)
    const interval = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.scrollBy({
          left: 220,
          behavior: "smooth",
        });
      }
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <section className="companies-section">
      <div className="companies-header" data-aos="fade-up">
        <h2 className="companies-title">Trusted by Industry Leaders</h2>
        <p className="companies-subtitle">
          We collaborate with global organizations to deliver impactful digital
          solutions.
        </p>
        <span className="company-underline"></span>
      </div>

      <div className="slider-wrapper" data-aos="fade-up" data-aos-delay="200">
        <button className="arrow left" onClick={scrollLeft}>&lt;</button>

        <div className="companies-slider" ref={sliderRef}>
          {[hcl, tcs, turing, genpact, lti].map((logo, i) => (
            <div className="company-logo" key={i}>
              <img src={logo} alt="Company logo" />
            </div>
          ))}
        </div>

        <button className="arrow right" onClick={scrollRight}>&gt;</button>
      </div>
    </section>
  );
};

export default Companies;
